import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHeader(true);
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  const navigation = [
    { name: 'Beranda', href: '/', type: 'route' },
    { name: 'Demo', href: '/demo', type: 'route' },
    { name: 'Fitur', href: '#integration', type: 'anchor' },
    { name: 'Kontak', href: '#contact', type: 'anchor' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-black/70 backdrop-blur-xl z-50 border-b border-white/10 shadow-lg shadow-black/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className={`flex items-center space-x-3 transition-all duration-1500 ease-out transform ${
            showHeader ? 'translate-x-0 opacity-100' : '-translate-x-15 opacity-0'
          }`}>
            <div className="relative">
              {!logoLoaded && (
                <div className="w-8 h-8 bg-gray-700 rounded animate-pulse"></div>
              )}
              <img 
                src="https://customer-assets.emergentagent.com/job_139a1b8f-e7a3-436b-b3e2-334218a84ff2/artifacts/ujujlmbw_Logo%20BTSSOFT%20Realistic%202025.09.png" 
                alt="BTSSOFT" 
                className={`h-8 w-auto transition-all duration-1200 ease-out transform ${
                  logoLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-120'
                }`}
                onLoad={() => setLogoLoaded(true)}
                onError={() => setLogoLoaded(true)}
              />
            </div>
            <div className={`transition-all duration-1000 ease-out ${logoLoaded ? 'opacity-100' : 'opacity-30'}`}>
              <h1 className="font-bold text-lg text-white">BTSSOFT</h1>
              <p className="text-xs text-gray-400">Software Developer</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => {
              if (item.type === 'route') {
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`transition-colors duration-200 font-medium ${
                      location.pathname === item.href 
                        ? 'text-blue-400' 
                        : 'text-gray-300 hover:text-blue-400'
                    }`}
                  >
                    {item.name}
                  </Link>
                );
              } else {
                return (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200 font-medium"
                  >
                    {item.name}
                  </a>
                );
              }
            })}
          </nav>

          <div className="hidden md:flex">
            <Button 
              className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105"
              onClick={() => window.open('https://api.whatsapp.com/send/?phone=6281218691110&text=Halo%20BTSSOFT%2C%20saya%20ingin%20konsultasi%20gratis%20mengenai%20XAI%20ERP%20System.%20Mohon%20informasi%20lebih%20lanjut.&type=phone_number&app_absent=0', '_blank')}
            >
              Konsultasi Gratis
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-black/80 backdrop-blur-xl border-b border-white/10 shadow-lg">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => {
                if (item.type === 'route') {
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`block px-3 py-2 hover:text-blue-400 hover:bg-gray-700 rounded-md font-medium ${
                        location.pathname === item.href 
                          ? 'text-blue-400 bg-gray-700' 
                          : 'text-gray-300'
                      }`}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  );
                } else {
                  return (
                    <a
                      key={item.name}
                      href={item.href}
                      className="block px-3 py-2 text-gray-300 hover:text-blue-400 hover:bg-gray-700 rounded-md font-medium"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {item.name}
                    </a>
                  );
                }
              })}
              <div className="px-3 py-2">
                <Button 
                  className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-full"
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    window.open('https://api.whatsapp.com/send/?phone=6281218691110&text=Halo%20BTSSOFT%2C%20saya%20ingin%20konsultasi%20gratis%20mengenai%20XAI%20ERP%20System.%20Mohon%20informasi%20lebih%20lanjut.&type=phone_number&app_absent=0', '_blank');
                  }}
                >
                  Konsultasi Gratis
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;